import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.847 3.446c.533-.533 1.198-.642 1.75-.406.523.224.903.748.903 1.36v8.795l6.843 6.44a.5.5 0 0 1-.686.73L13.5 14.567V19.6c0 .684-.512 1.132-1.017 1.3-.508.17-1.171.119-1.636-.346L5.793 15.5H2c-.414 0-.797-.14-1.078-.422C.64 14.797.5 14.413.5 14v-4c0-.414.14-.798.422-1.08.281-.28.665-.42 1.078-.42h3.793l.61-.61-3.746-3.526a.5.5 0 0 1 .686-.728L7.11 7.182l3.737-3.736ZM6.207 9.5H2c-.186 0-.302.06-.371.128S1.5 9.814 1.5 10v4c0 .186.06.302.129.371s.185.129.371.129h4.207l.147.146 5.2 5.2c.135.135.372.184.613.104.245-.082.333-.235.333-.35v-5.972L7.13 8.575l-.923.925ZM20.27 5.823a.501.501 0 0 1 .707.047C22.43 7.531 23.5 9.645 23.5 12c0 2.32-.845 4.451-2.347 5.953a.5.5 0 0 1-.707-.707C21.744 15.948 22.5 14.079 22.5 12c0-2.045-.93-3.933-2.276-5.47a.501.501 0 0 1 .046-.707ZM17.2 9.1a.5.5 0 0 1 .7-.1c.899.675 1.6 1.813 1.6 3 0 1.189-.701 2.327-1.6 3a.5.5 0 0 1-.6-.8c.7-.526 1.2-1.388 1.2-2.2 0-.81-.5-1.674-1.2-2.2a.5.5 0 0 1-.1-.7Zm-4.997-5.14c-.148-.064-.383-.072-.65.194L7.84 7.867l4.661 4.387V4.399a.489.489 0 0 0-.297-.44Z",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }